import React from 'react'
import JobTotals from './dashboard/JobTotals'
import JobByTimeAndStatus from './dashboard/JobByTimeAndStatus'
import JobByType from './dashboard/JobByType'
import JobByAccount from './dashboard/JobByAccount'
import ServerByAvgLoad from './dashboard/ServerByAvgLoad'

export default class DashBoard extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      loading: false
    }
  }
  render(){
    return(
      <div className='container'>
        <div className = 'row mb10'>
          <h1 className='titleHead'>Jobs Dashboard</h1>
        </div>
        <div className='row mb20'>
          <div className = 'col-md-4'><JobTotals time={'24'}/></div>
          <div className = 'col-md-4'></div>
          <div className = 'col-md-4'><JobByType time={'24'}/></div>
        </div>
        <div className='row'>
          <div className = 'col-md-6'><JobByTimeAndStatus/></div>
          <div className = 'col-md-6'><JobByAccount time={'24'}/></div>
        </div>
        <div className = 'row mb10'>
          {/* <h1 className='titleHead'>Servers Metrics</h1> */}
        </div>
        {/* <div className = 'row'>
          <div className = 'col-md-12'><ServerByAvgLoad/></div>
        </div> */}
    </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Dashboard.js